declare var $: any;
const moment = require('moment');
require('moment-duration-format');

export class Helper {
	static FormateDate(date: Date, toLocal = false): string {
		let result = moment(date).format('YYYY-MM-DD HH:mm:ss');

		// If they want local time, convert from UTC
		if (toLocal) {
			const utcDate = moment.utc(result).toDate();
			result = moment(utcDate).local().format('YYYY-MM-DD HH:mm:ss');
		}

		return result;
	}
	static FormateDateOnly(date: Date): string {
		return moment(date).format('YYYY-MM-DD');
	}
	static TimeToDuration(chosenDate: Date): string {
		let duration = moment(chosenDate).diff(moment());
		return moment.duration(duration).format('hh:mm:ss', { trim: false });
	}

	static TimeFromDuration(durationString: string): Date {
		let duration = moment.duration(durationString);
		return moment().add(duration);
	}
	static TimeFromTimeAndDuration(durationString: string, timeIni: Date): Date {
		let duration = moment.duration(durationString);
		return moment(timeIni).add(duration);
	}
	static DurationToMs(durationString: string): number {
		return moment.duration(durationString);
	}

	static PadStart(num: Number) {
		return ('0' + num).slice(-2);
	}

	/**
	 * @deprecated DANGER!!!!: use Helper.alert() instead!
	 * Avoid using this function, use the new function instead.
	 * @param from top or bottom
	 * @param align right or left
	 * @param mess message to display. This supports HTML example: Welcome to <b>Paper Dashboard</b> - a beautiful dashb
	 * @param alerttype 0 is none, 1 is info, 2 is success, 3 is warning, 4 is danger
	 */
	static showNotification(
		from: string,
		align: string,
		mess: string,
		alertType: number,
		myIcon: string = 'ti-alert'
	) {
		var type = ['', 'info', 'success', 'warning', 'danger'];

		//var color = Math.floor((Math.random() * 4) + 1);
		$.notify(
			{
				icon: myIcon,
				message: mess
			},
			{
				type: type[alertType],
				timer: 4000,
				placement: {
					from: from,
					align: align
				}
			}
		);
	}
	/**
	 *
	 * @param mess message to display. This supports HTML example: Welcome to <b>Paper Dashboard</b> - a beautiful dashb
	 * @param from "top" or "bottom" default is top
	 * @param align "right" or "left" default is left
	 * @param alertType 0 is none, 1 is info, 2 is success, 3 is warning, 4 is danger
	 * @param myIcon default is "ti-alert", check documantation for more icons
	 */
	static alert(
		mess: string,
		alertType: number = 4,
		from: string = 'top',
		align: string = 'right',
		myIcon: string = 'ti-alert',
		timeout: number = 4000
	) {
		var type = ['', 'info', 'success', 'warning', 'danger'];

		//var color = Math.floor((Math.random() * 4) + 1);
		$.notify(
			{
				icon: myIcon,
				message: mess
			},
			{
				type: type[alertType],
				timer: timeout,
				placement: {
					from: from,
					align: align
				}
			}
		);
	}
	// static showNotification(from, align){
	//         var type = ['','info','success','warning','danger'];

	//         var color = Math.floor((Math.random() * 4) + 1);

	//       $.notify({
	//           icon: "ti-gift",
	//           message: "Welcome to <b>Paper Dashboard</b> - a beautiful freebie for every web developer."
	//         },{
	//             type: type[color],
	//             timer: 4000,
	//             placement: {
	//                 from: from,
	//                 align: align
	//             }
	//         });
	//     }
}
// export interface Array<T> {
//     find(predicate: (search: T) => boolean) : T;
// }



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/libraries/Helper.ts